
export default function Doc() {
    return (
        <div className="document">
            <div className="">
                <img  src="./images/code-1839406_1280.jpg" />
            </div>
            <h6> لیسانس بهترین برنامه نویس </h6>
        </div>
    )
}
